/**
 * @typedef HomadDOM
 * @property {HTMLVideoElement} video
 * @property {HTMLDivElement} container
 * @property {HTMLDivElement} uiContainer
 * @property {HTMLDivElement} playButton
 * @property {HTMLDivElement} muteButton
 */

/**
 * Get Ad Player from player container
 *
 * @param {HTMLDivElement} playerContainer
 * @return {HomadDOM}
 */
export function parseHomadDOM(playerContainer) {
    const videoElements = playerContainer.querySelectorAll('video');
    const [video] = [...videoElements].filter((v) => !v.className);
    if (!video) return undefined;

    /**
     * [div] homad main container
     * └─ [div]
     *    ├─ [video] click event goes to the advertiser
     *    ├─ [div] variuos visual controls and labels
     *    └─ [div] buttons container
     *       ├─ [div] play button
     *       └─ [div] mute button
     */
    const container = video.parentNode.parentNode;
    const uiContainer = video.nextElementSibling;
    const [playButton, muteButton] = uiContainer.nextElementSibling.childNodes;

    return {
        video,
        container,
        uiContainer,
        playButton,
        muteButton,
    };
}
